import { ITableData } from './common';

export interface IRiskSupplementWarningTypeResponseDTO {
  id: number | null;
  name: string;
  description?: string;
}

export interface IRiskSupplementImagesResponseDTO {
  id: number | null;
  url: string;
  name: string;
}

export interface IHighRiskSupplementResponseDTO {
  id: number;
  name: string;
  category: string;
  company: string;
  statusDate: string;
  warningTypes: IRiskSupplementWarningTypeResponseDTO[];
  image: IRiskSupplementImagesResponseDTO;
}

export interface IHighRiskSupplementDetailsResponseDTO {
  statusDate: string;
  riskSupplementCategory: string;
  riskSupplementCompany: string;
  fdaLetter: string;
  productInfo: string;
  comments: string;
  warningTypeDtos: IRiskSupplementWarningTypeResponseDTO[];
  images: IRiskSupplementImagesResponseDTO[];
  drugClasses: string[];
  ingredients: string[];
  id: number;
  name: string;
}

export interface IHighRiskSupplementCategoryDTO {
  id: number;
  name: string;
}

export interface IHighRiskSupplementSearchDTO {
  page: number;
  searchValue: string;
  selectedCategory?: number | string;
}

export type IRiskSupplementsTableData = ITableData<IHighRiskSupplementResponseDTO>;

export enum WarningType {
  AntiDopping = 1,
  Regulatory = 2,
  AnalyticalFinding = 3,
}
